import Vue from "vue";
//模块功能：产品服务
export default Vue.extend({
    name: "p-track",
    data: function () {
        return {
            crtMenu: 'p1',
        };
    },
    mounted: function () {
    },
    methods: {
        /**
         * 功能：切换菜单
         * @param val
         */
        setMenu: function (val) {
            this.crtMenu = val;
        },
        /**
         * 功能：切换路由
         * @param val
         */
        toPage: function (val) {
            this.$router.push(val);
        }
    },
    computed: {
        menuList: function () {
            return this.$t('productmenu');
        },
        products: function () {
            var temp = this.$t('products');
            var url = "../../../static/img/product/";
            for (var _i = 0, _a = temp['p2']; _i < _a.length; _i++) {
                var item = _a[_i];
                item.img = url + item.img;
            }
            return temp;
        }
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/p-track.vue
// module id = null
// module chunks = 